var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'shadow-around relative flex h-auto max-h-full w-full flex-col overflow-hidden rounded-lg bg-white pb-1 pt-4 dark:bg-neutral-900 md:rounded-2xl md:pb-3',
    {
      'md:w-100': _vm.size === 'sm',
      'md:w-120 md:pt-6': _vm.size === 'md',
      'md:w-140': _vm.size === 'lg',
    },
  ]},[(_vm.closable)?_c('button',{staticClass:"size-9 absolute right-2 top-2 flex shrink-0 cursor-pointer items-center justify-center justify-center rounded-lg bg-white px-0 text-gray-500 hover:bg-gray-100 dark:bg-neutral-900 dark:text-neutral-300 dark:hover:bg-neutral-800 md:rounded-xl",on:{"click":function($event){$event.preventDefault();return _vm.closeModal.apply(null, arguments)}}},[_c('lucide-icon',{attrs:{"icon":"X","size":"22"}})],1):_vm._e(),_c('div',{staticClass:"custom-scroll-y max-h-full w-full grow overflow-auto px-2"},[_c('div',{staticClass:"mx-auto w-full",class:{
        'md:max-w-90': _vm.size === 'sm',
        'md:max-w-105': _vm.size === 'md',
        'md:w-120': _vm.size === 'lg',
      }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }